/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RequestEmailUpdateBody
 */
export interface RequestEmailUpdateBody {
    /**
     * 
     * @type {string}
     * @memberof RequestEmailUpdateBody
     */
    email: string;
}

/**
 * Check if a given object implements the RequestEmailUpdateBody interface.
 */
export function instanceOfRequestEmailUpdateBody(value: object): value is RequestEmailUpdateBody {
    if (!('email' in value) || value['email'] === undefined) return false;
    return true;
}

export function RequestEmailUpdateBodyFromJSON(json: any): RequestEmailUpdateBody {
    return RequestEmailUpdateBodyFromJSONTyped(json, false);
}

export function RequestEmailUpdateBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): RequestEmailUpdateBody {
    if (json == null) {
        return json;
    }
    return {
        
        'email': json['email'],
    };
}

export function RequestEmailUpdateBodyToJSON(json: any): RequestEmailUpdateBody {
    return RequestEmailUpdateBodyToJSONTyped(json, false);
}

export function RequestEmailUpdateBodyToJSONTyped(value?: RequestEmailUpdateBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'email': value['email'],
    };
}

